export const respiratory = (() => {
    const placeHolderText = 'Today has a mild cough but no sputum or trouble breathing or wheezing '

    return placeHolderText
})